import { FormControl as MuiFormControl, InputLabel, FormHelperText, Theme } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  name: string;
  label?: ReactNode;
  error?: string;
  className?: string;
  fullWidth?: boolean;
  children: ReactNode;
  size?: 'tiny' | 'small' | 'medium';
}

const useStyles = createUseStyles((theme: Theme) => ({
  helperText: {
    marginLeft: 0,
  },
  formControl: {
    '& label.MuiFormLabel-root.Mui-focused': {
      color: theme.palette.text.primary,
    },
    '& div.MuiInputBase-root': {
      '& fieldset': {
        borderColor: `${theme.palette.grey[500]} !important`,
      },
    },
  },
}));

const FormControl: FC<Props> = ({
  className = '',
  name,
  children,
  label = '',
  error = '',
  fullWidth = true,
  size = 'medium',
}) => {
  const styles = useStyles();
  const hasError = !!error;
  const hasLabel = !!label;
  const labelId = `${name}-label`;
  const compClass = classNames(className, styles.formControl);
  const isSmall = ['small', 'tiny'].includes(size);

  return (
    <MuiFormControl
      fullWidth={fullWidth}
      className={compClass}
      margin="normal"
      size={isSmall ? 'small' : 'medium'}
    >
      {hasLabel && <InputLabel id={labelId}>{label}</InputLabel>}
      {children}
      {hasError && (
        <FormHelperText className={styles.helperText} error>
          {error}
        </FormHelperText>
      )}
    </MuiFormControl>
  );
};

export default FormControl;
